export default {
	options: [{
		value: '0',
		label: '上海速元科技有限公司'
	}, {
		value: '1',
		label: '上海速元科技有限公司'
	}],

	searchlist: [{
			prop: "sellerTaxNumber",
			label: '销方税号',
			type: "input"
		},
		{
			prop: "nsrmc",
			label: '企业名称',
			type: "input"
		},
		{
			prop: "invoiceType",
			label: '发票类型',
			type: "select",
			selectval: [{
					label: "专票",
					value: "1"
				},
				{
					label: "普票",
					value: "2"
				},
			]
		},
		{
			prop: "openInvoiceMonth",
			label: '开票月份',
			type: "datemonth",
			valueformat: 'yyyyMM'
		},
		{
			prop: "openInvoiceProject",
			label: '开票项目',
			type: "input"
		},
		{
			prop: "coilNumber",
			label: '盘号',
			type: "input"
		},
		{
			prop: "remarks",
			label: '备注',
			type: "input"
		},
	],
	tableData: [],
	searchdata: {
		sellerTaxNumber: "",
		invoiceType: "",
		openInvoiceProject: "",
		coilNumber: "",
		remarks: "",
		openInvoiceMonth: "",
	},
	headData: [{
		title: "销方税号",
		prop: "sellerTaxNumber",
		width: 160,
		align: "left"

	},{
		prop:'nsrmc',
		title: '企业名称',
		width: 160,
	}, {
		title: "发票类型",
		prop: "invoiceType",
		custom: true,
		width: 80,
	}, {
		title: "开票月份",
		prop: "openInvoiceMonth",
		width: 80,
	}, {
		title: "开票项目",
		prop: "openInvoiceProject",
		width: 80,
	}, {
		title: "税率",
		prop: "taxRate",
		custom: true,
		width: 80,
	}, {
		title: "金额",
		prop: "amount",
		width: 80,
		AmountFormat: true,
		align: "right"
	}, {
		title: "税额",
		prop: "tax",
		width: 80,
		AmountFormat: true,
		align: "right"
	}, {
		title: "盘号",
		prop: "coilNumber",
		width: 160,
		align: "left"
	}, {
		title: "备注",
		prop: "remarks",
		width: 160,
		align: "left"
	},{
		title: "操作",
		prop: "cz",
		width: "200",
		fixed:"right",
		custom:true
	},],
	outputData: {
		exportType: "",
		shenbq: "",
	},
	pagination: {
		pageNum: 1,
		pageSize: 50,
		total: 0,
		paginationkey: 0
	}
}
